// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ButtonTsx from "./Button.tsx";

let make = ButtonTsx.Button;

export {
  make,
}
/* make Not a pure module */
